import React, { useEffect, useState } from 'react';
import { FaVolumeUp } from 'react-icons/fa';
import { getAnnouncementAPI } from '../../service/AuthService';

const AnnouncementBar = () => {
  const [text, setText] = useState(null);

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const res = await getAnnouncementAPI();
        const data = res?.data || res;
        if (data?.code === 200 && data.response?.announcement) {
          setText(data.response.announcement);
        }
      } catch {
        // no announcement to show
      }
    };
    fetchAnnouncement();
  }, []);

  if (!text) return null;

  return (
  <>
    <style>{`
      @keyframes announcement-scroll {
        0% { transform: translateX(0); }
        100% { transform: translateX(-100%); }
      }
      .announcement-bar {
        display: flex;
        align-items: center;
        background-color: #333;
        width: 100%;
        height: 34px;
        overflow: hidden;
      }
      .announcement-bar__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #1a8c1a;
        color: #fff;
        font-size: 16px;
        width: 36px;
        height: 34px;
        flex-shrink: 0;
        z-index: 1;
      }
      .announcement-bar__scroll {
        flex: 1;
        overflow: hidden;
        height: 34px;
        line-height: 34px;
        min-width: 0;
      }
      .announcement-bar__track {
        display: inline-block;
        white-space: nowrap;
        animation: announcement-scroll 25s linear infinite;
        font-size: 13px;
        font-weight: 700;
        font-style: italic;
        color: #fff;
      }
      @media (max-width: 768px) {
        .content-box-main .announcement-bar {
          display: none;
        }
        .announcement-bar {
          height: 30px;
        }
        .announcement-bar__icon {
          width: 30px;
          height: 30px;
          font-size: 13px;
        }
        .announcement-bar__scroll {
          height: 30px;
          line-height: 30px;
        }
        .announcement-bar__track {
          font-size: 11px;
        }
      }
    `}</style>
    <div className="announcement-bar">
      <span className="announcement-bar__icon">
        <FaVolumeUp />
      </span>
      <div className="announcement-bar__scroll">
        <span className="announcement-bar__track">
          {text}
        </span>
      </div>
    </div>
  </>
  );
};

export default AnnouncementBar;
